import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "create_new_col_modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "create_new_col_modal"
  }, " Create new Contact on location "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "d-flex flex-stack mb-3 cursor-pointer" }
const _hoisted_9 = { class: "d-flex align-items-center me-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-50px me-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-gray-600" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, [
          /*#__PURE__*/_createElementVNode("polygon", { points: "0 0 24 0 24 24 0 24" }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z",
            fill: "#000000",
            "fill-rule": "nonzero",
            opacity: "0.3"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z",
            fill: "#000000",
            "fill-rule": "nonzero"
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = {
  key: 0,
  class: "fw-bolder text-gray-800 text-hover-primary fs-5"
}
const _hoisted_13 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 required" }, "Name", -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Phone", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Email", -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = {
  key: 0,
  class: "col-12"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 required" }, "Password", -1)
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Create ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          validationSchema: _ctx.validationSchema,
          onSubmit: _ctx.submit,
          ref: "formComponent"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, [
                        (_ctx.client)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.client.label) + " employee", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.isEmployee) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.data.isEmployee]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: "Enter name",
                    name: "name",
                    modelValue: _ctx.data.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_ErrorMessage, { name: "name" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: "Enter phone",
                    name: "phone",
                    modelValue: _ctx.data.phone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.phone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: "Enter email",
                    name: "email",
                    modelValue: _ctx.data.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.email) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                (_ctx.data.isEmployee)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-solid",
                        placeholder: "Enter password",
                        name: "password",
                        modelValue: _ctx.data.password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.password) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ErrorMessage, { name: "password" })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("button", {
                class: "btn btn-success",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                  : _createCommentVNode("", true),
                _hoisted_34
              ], 8, _hoisted_32)
            ])
          ]),
          _: 1
        }, 8, ["validationSchema", "onSubmit"])
      ])
    ])
  ]))
}